import React from 'react';
import { Box, Heading } from '@wix/design-system';
import { SearchBox } from '@wix/app-market-components';
import {
  useEssentials,
  useRouterContext,
  AppMarketPage,
  useTranslation,
  useSiteContext,
} from '@wix/app-market-core';
import { RoutePath } from '@wix/app-market-core-types';
import { useSearchBoxActions } from '../../components/search-box/hooks/search-box-actions';
import { BackButton } from '../../components/back-button';
import { appMarketBackButtonClick } from '@wix/bi-logger-app-market-data/v2';
import s from './header.scss';

interface HeaderProps {
  searchTerm: string;
  isAppsFound: boolean;
}

export function Header({ searchTerm, isAppsFound }: HeaderProps) {
  const pageName = AppMarketPage.SEARCH_RESULT;
  const { experiments, biLogger } = useEssentials();
  const { languageCode, horizontalNav } = useSiteContext();
  const { router } = useRouterContext();
  const { onSelect, onChange, onFocus, onEnterPressed } = useSearchBoxActions(
    pageName,
    pageName,
  );
  const { t } = useTranslation();

  function onBack() {
    biLogger.report(
      appMarketBackButtonClick({
        tag_type: pageName,
        tag_name: searchTerm,
        location: 'search_result_page',
      }),
    );
    router.navigateTo({
      path: RoutePath.BACK,
      payload: undefined,
    });
  }

  return (
    <Box direction="vertical" marginTop="24px" marginBottom="24px">
      <Box>
        <Box flex={2} direction="vertical">
          {router.hasHistory() && (
            <BackButton
              onBack={onBack}
              size="small"
              weight="thin"
              skin="dark"
            />
          )}
          {isAppsFound && (
            <Heading dataHook="search-result-title" size="large">
              {t('search.results.page.title', {
                searchTerm,
                interpolation: { escapeValue: false },
              })}
            </Heading>
          )}
        </Box>
        {!horizontalNav && (
          <Box
            className={s.searchBoxContainer}
            flex={1}
            marginTop={isAppsFound ? '16px' : undefined}
          >
            <SearchBox
              dataHook="search-box-search-results"
              givenSearchTerm={searchTerm}
              onChange={onChange}
              onSelect={onSelect}
              onEnterPressed={onEnterPressed}
              onFocus={onFocus}
              languageCode={languageCode}
              experiments={experiments}
              size="medium"
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}
